import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import EligibilityCheck from "../components/EligibilityCheck";
import { postAllPatientRecord } from "../../../actions/AllPatientRecords";
import { ApplicationState } from "../../../store/ApplicationState";
import { AllPatientDispatchTypes } from "../../../models/DispatchTypes/AllPatientRecord";
import { SearchPayloadForRecords } from "../../../models/Authorization";
import { resetStates } from "../../../actions/Common";

const mapStateToProps = ({
    allPatientRecordState,
}: ApplicationState) => ({
    allPatientRecord: allPatientRecordState,
});

type DispatchTypes = AllPatientDispatchTypes;

const mapDispatchToProps = (
    dispatch: ThunkDispatch<
        ApplicationState,
        Record<string, never>,
        DispatchTypes
    >
) => {
    return {
        postAllPatientRecord: (payload?: SearchPayloadForRecords) => {
            dispatch(postAllPatientRecord(payload));
        },
        resetStates: (actionType: string[]) => {
            dispatch(resetStates(actionType));
          },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(EligibilityCheck);